<template>
  <div
    class="cpt-chat-circle-loading relative rounded-full"
    :style="{
      width: size + 'px',
      height: size + 'px',
    }"
  >
    <div class="loading-item rounded-full"></div>
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: Number | String,
      default: '16',
    },
  },
  name: 'ChatMoreLoading',
};
</script>
<style lang="scss">
.cpt-chat-circle-loading {
  border: 2px solid $d-tx-4;
  .loading-item {
    border: 2px solid transparent;
    border-left: 2px solid $d-bd-tx;
    position: absolute;
    top: -2px;
    left: -2px;
    bottom: -2px;
    right: -2px;
    animation: rotate 1s linear infinite;
  }
}
</style>
